var map = {
	"./en.json": [
		27473,
		473
	],
	"./es.json": [
		56018,
		18
	],
	"./fr.json": [
		47946,
		946
	],
	"./hu.json": [
		48689,
		689
	],
	"./keys.json": [
		96838,
		838
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57995;
module.exports = webpackAsyncContext;